"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNumericalityValidations;
var _lodash = require("lodash");
var _validations = _interopRequireDefault(require("../../../utils/validations"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function getNumericalityValidations(validator) {
  var filteredValidators = (0, _lodash.uuPick)(validator, ['only_integer', 'greater_than', 'greater_than_or_equal_to', 'equal_to', 'not_equal_to', 'less_than', 'less_than_or_equal_to']);
  var result = (0, _lodash.reduce)(filteredValidators, function (acc, arg, key) {
    switch (key) {
      case 'only_integer':
        {
          if (!arg) {
            return acc;
          }
          return [].concat(_toConsumableArray(acc), [function (value) {
            return _validations["default"].isInteger(value, validator.message);
          }]);
        }
      case 'equal_to':
        return [].concat(_toConsumableArray(acc), [function (value) {
          return _validations["default"].isEqual(parseFloat(value, 10), validator.message, arg);
        }]);
      case 'not_equal_to':
        return [].concat(_toConsumableArray(acc), [function (value) {
          return _validations["default"].isDifferent(parseFloat(value, 10), validator.message, arg);
        }]);
      case 'greater_than':
        return [].concat(_toConsumableArray(acc), [function (value) {
          return _validations["default"].isGreaterThan(parseFloat(value, 10), validator.message, arg);
        }]);
      case 'less_than':
        return [].concat(_toConsumableArray(acc), [function (value) {
          return _validations["default"].isLessThan(parseFloat(value, 10), validator.message, arg);
        }]);
      case 'greater_than_or_equal_to':
        return [].concat(_toConsumableArray(acc), [function (value) {
          return _validations["default"].isGreaterOrEqualThan(parseFloat(value, 10), validator.message, arg);
        }]);
      case 'less_than_or_equal_to':
        return [].concat(_toConsumableArray(acc), [function (value) {
          return _validations["default"].isLessOrEqualThan(parseFloat(value, 10), validator.message, arg);
        }]);
      default:
        return acc;
    }
  }, []);
  return result;
}